/*global jQuery:readonly */
import * as React from "react";

import { Notification } from "./data";
import { checkLogin } from "./helpers";

import logo from "./R-64.png";

interface NavState {
    notificationCount: number;
    notifications: Notification[];
}

class Nav extends React.Component<{}, NavState> {
    state: NavState = {
        notificationCount: 0,
        notifications: [],
    };

    private notificationsLoaded: boolean = false;
    private timeout: number = 1000;

    get notifications(): JSX.Element[] {
        if (!this.notificationsLoaded) {
            return [
                <li key="loading">
                    <a>Loading...</a>
                </li>,
            ];
        }

        if (!this.state.notifications.length) {
            return [
                <li key="done">
                    <a>All done here ☺</a>
                </li>,
            ];
        }

        return this.state.notifications.map(
            (notification): JSX.Element => {
                let text: string | JSX.Element | JSX.Element[];
                if (notification.type !== 0) {
                    text = (
                        <>
                            <span className="agent">{ notification.user }</span>
                            <span>{ notification.text }</span>,
                        </>
                    );
                }
                else {
                    text = notification.text;
                }

                return (
                    <li key="notification-link">
                        <a href={ notification.link }>
                            <div className="unread">
                                { notification.unread && (
                                    <span className="glyphicon glyphicon-certificate"/>
                                ) }
                                &nbsp;
                            </div>
                            <div className="time">{ notification.time }</div>
                            <div className="text">{ text }</div>
                        </a>
                    </li>
                );
            }
        );
    }


    constructor(props) {
        super(props);
        this.refreshNotifications = this.refreshNotifications.bind(this);
    }

    componentDidMount(): void {
        jQuery("#notificationdropdown").on("show.bs.dropdown", (): void => {
            jQuery.getJSON("/backend/notifications").then((data: any): void => {
                this.notificationsLoaded = true;
                this.setState({ notifications: data });
            }, checkLogin);
        });
    }

    UNSAFE_componentWillMount(): void {
        this.refreshNotifications();
    }

    refreshNotifications(): void {
        jQuery.getJSON("/backend/notificationCheck").then((data): void => {
            this.setState({ notificationCount: +data.notifications });

            if (this.timeout < 300000) {
                this.timeout += 10000;
            }

            setTimeout(this.refreshNotifications, this.timeout);
        }, checkLogin);
    }

    render(): JSX.Element {
        const notificationCount = this.state.notificationCount;

        return (
            <nav
                className="navbar navbar-default navbar-fixed-top navbar-inverse"
                role="navigation"
            >
                <div className="container-fullwidth">
                    <div className="navbar-header">
                        <div className="navbar-brand navbar-brand-centered">
                            <a className="navbar-brand" href="/">
                                <img src={ logo } alt="The Grid Logo"/>
                                <span className="sr-only">The Grid</span>
                            </a>
                        </div>
                    </div>

                    <div className="nav" id="navbar-brand-centered">
                        <ul className="nav navbar-nav">
                            <li className="dropdown">
                                <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                                    <span
                                        className="glyphicon glyphicon-menu-hamburger"
                                        style={ { fontSize: "1.4em" } }
                                    />
                                </a>
                                <ul className="dropdown-menu" role="menu">
                                    <li>
                                        <a href="/r?page=newtoplist">Toplist</a>
                                    </li>
                                    <li>
                                        <a href="/r?page=regions">Top agents by region</a>
                                    </li>
                                    <li>
                                        <a href="/compare">Compare agents</a>
                                    </li>
                                    <li>
                                        <a href="/toolbox">Admin Toolbox</a>
                                    </li>
                                    <li>
                                        <a href="/update">Update score</a>
                                    </li>
                                    <li>
                                        <a href="/r?page=log">Log</a>
                                    </li>
                                    <li>
                                        <a href="/agent/progress">Progress</a>
                                    </li>
                                    <li>
                                        <a href="/settings">Settings</a>
                                    </li>
                                    <li>
                                        <a href="/groups">Groups</a>
                                    </li>
                                    <li>
                                        <a href="/contact">Contact and Help</a>
                                    </li>
                                    <li>
                                        <a href="/logout">Logout</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            <li id="notificationdropdown" className="dropdown">
                                <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                                    <i
                                        id="notifications"
                                        className={ `glyphicon glyphicon-star ${
                                            notificationCount > 0 ? "red" : ""
                                        }` }
                                        style={ { paddingRight: "16px", fontSize: "1.4em" } }
                                    />
                                    <i className="sr-only">Notifications</i>
                                </a>
                                <ul id="notification-collapse" className="dropdown-menu">
                                    { this.notifications }
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Nav;
